import { Scale } from "../../../utils/Scale"

export class ShPos {

    static lungsX = () => Scale.width() * 0.5
    static lungsY = () => Scale.height() * 0.5

    static lungsTitleX = () => Scale.width() * 0.47
    static lungsTitleY = () => Scale.height() * 0.77

    static mouseX = () => Scale.width() * 0.75
    static mouseY = () => Scale.height() * 0.42

    static mouseTitleX = () => Scale.width() * 0.68
    static mouseTitleY = () => Scale.height() * 0.38

    static scientistX = () => Scale.width() * 0.52
    static scientistY = () => 0

    static skeletonX = () => Scale.width() * 0.43
    static skeletonY = () => 0

    static fullDeskY = () => Scale.height() * 0.02

    static backToMuseumX = () => Scale.width() * 0.1
    static backToMuseumY = () => Scale.height() * 0.85

    static shortTermVaporExperimentX = () => Scale.width() * 0.26
    static shortTermVaporExperimentY = () => Scale.height() * 0.37

    static shortTermVaporExperimentTitleX = () => Scale.width() * 0.2
    static shortTermVaporExperimentTitleY = () => Scale.height() * 0.66

    static shortTermSmokingExperimentX = () => Scale.width() * 0.02
    static shortTermSmokingExperimentY = () => Scale.height() * 0.23

    static shortTermSmokingExperimentTitleX = () => Scale.width() * 0.02
    static shortTermSmokingExperimentTitleY = () => Scale.height() * 0.2

}
